import AppModal from "components/Modal"; 
import React, { 
    useEffect, 
    useState, 
}  from 'react';
import ReactDOM from "react-dom"; 
import { useAuth } from '../../../helpers/authContext';

import {
    // Alert,
    Button, 
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Row, 
} from "reactstrap"; 
import { useToast } from "components/ui/use-toast"; 
import useModal from "helpers/useModal";
import LoginModal from "./LoginModal";
import { getUser } from "services/user-service"; 
import { isLoggedWithKeychain } from "services/dsteem-service";
import { transferToSavingsKeychain } from "helpers/keychain";
import { transferToSavingsWithWif } from "helpers/steem"; 
type Props = {
  isShowing: boolean,
  hide: any, 
  symbol?:string,
  onSuccess?: () => void;
}

export const TransferToSavingsModal = ({ isShowing, hide,  symbol="STEEM", onSuccess = null}: Props) => { 
    const { user, autologin } = useAuth(); 
    const [requiredActive, setRequiredActive] = useState<any>(true);
    const [isTransferring, setIsTransferring] = useState(false); 
    const keychainLogin = isLoggedWithKeychain(autologin);
    const [availableSBD, setAvailableSBD] = useState<any>(0);
    const [availableSTEEM, setAvailableSTEEM] = useState<any>(0);
    const [transferReceiver, setTransferReceiver] = useState<any>(user); 
    const [transferAmount, setTransferAmount] = useState<any>(0);
    const [step, setStep] = useState<any>(1);
    const [showConfirm, setShowConfirm] = useState(false);
    const [transferSymbol, setTransferSymbol] = useState<any>(symbol); 
    const { isOpenLoginModal, toggleLoginModal  } = useModal();
    const { toast } = useToast();
    useEffect(()=> { 
        async function getAvailableFunds (){
            try {
                const [userInfo] = await Promise.all([ 
                    getUser(user),
                ]);
                setAvailableSBD(parseFloat(userInfo?.sbd_balance) || 0)
                setAvailableSTEEM(parseFloat(userInfo?.balance) || 0)
            } catch (error) {
                toast({title:"Error", description:error, variant:"rose_red"});
            }
            
        }
        getAvailableFunds(); 
    },[isShowing]); 


    const handleTransfer = async (newWif = "") => { 
        if (transferAmount) { 
            const fn = keychainLogin ? transferToSavingsKeychain : transferToSavingsWithWif;
            const account = keychainLogin ? user : autologin; 
            setIsTransferring(true);
            let res:any = await fn(account, parseFloat(transferAmount), transferSymbol, transferReceiver, newWif);
            setIsTransferring(false);
            if (!res.success) { 
                if(res?.message.toString().includes("Missing Active Authority")){ 
                    setRequiredActive(true);
                    toggleLoginModal();
                    return;
                } else {
                   toast({
                        title:"Failed sending funds.",
                        description:res,
                        variant:"rose_red"
                    }); 
                }
                
            }else {
                toast({
                title:"Funds saved successfully.",
                description:"You have saved your funds.",
                variant:"wild_green"
                }); 
                setTransferAmount(0);
                setTransferReceiver(""); 
                setStep(1);
                setShowConfirm(false);
                if (onSuccess) {
                    onSuccess();
                }
                
                hide();
            }
        }else{
            toast({
                title:"Failed sending funds.",
                description:"You need to set an amount.",
                variant:"rose_red"
            });
        }
    }
    const renderForm = (
        <div className="modal-body post-editor-body p-0">
        <Card className="no-shadow border-0">
            {user && (
                <CardBody className="px-lg-3 py-lg-3 body-gray"> 
                    {step == 1 && (
                        <Row>
                            <Col md="12">
                                <p className="promotion-description">
                                    Protect your funds by moving them to Savings.
                                    Saved funds are locked and can be withdrawn after 3 days.
                                </p>   
                            </Col>
                            <Col md="12">
                                <FormGroup>
                                    <div className="input-icon-group">
                                        <i className="fas fa-user input-icon" />
                                        <input type="text" className="form-control fancy-input" name="receiver" placeholder="Recipient" value={transferReceiver} onChange={(e) => setTransferReceiver((e.target.value))} />
                                    </div>
                                </FormGroup> 
                            </Col>
                            <Col className="col-8" md="8"> 
                                <FormGroup>
                                    <div className="input-icon-group">
                                        <i className="fas fa-coins input-icon" />
                                        <input type="number" className="form-control fancy-input" name="val" placeholder="Amount" value={transferAmount} onChange={(e) => setTransferAmount(parseFloat(e.target.value))} /> 
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col className="col-4" md="4"> 
                                <Input type="select" className="form-control fancy-input " name="symbol" value={transferSymbol} onChange={(e) => setTransferSymbol(e.target.value)} >
                                    <option value="STEEM">STEEM</option>
                                    <option value="SBD" >SBD</option>
                                </Input> 
                            </Col>
                            <Col md="12">
                                <span
                                    className="text-muted mb-3"
                                    style={{ cursor: "pointer" }} 
                                    >
                                    Available: <span onClick={() => {setTransferAmount(availableSBD);setTransferSymbol("SBD");}}>{availableSBD.toFixed(3)} SBD</span> | <span onClick={() => {setTransferAmount(availableSTEEM); setTransferSymbol("STEEM");}}>{availableSTEEM.toFixed(3)} STEEM</span>
                                </span>
                            </Col> 
                            {/* <Col md="12">
                                <FormGroup>
                                    <input type="text" className="form-control fancy-input mt-2" name="memo" placeholder="Memo" value={transferMemo} onChange={(e) => setTransferMemo((e.target.value))} />
                                    <sup>* This is optional but required for some exchangers.</sup>
                                </FormGroup> 
                            </Col> */}
                            <Col md="12"> 
                                <Button color="default" className="w-100 btn-fancy" onClick={() => {
                                    if (transferAmount && transferReceiver && transferSymbol) {
                                        setShowConfirm(true);
                                    }else {
                                        toast({title:"Fill all fields first", description:"Set a proper account name, amount, and symbol.", variant:"rose_red"});
                                    }
                                }}>
                                    Next <i className="fas fa-chevron-right ml-2" />
                                </Button> 
                            </Col>
                        </Row>
                    )}
                </CardBody>
            )}
            {!user && (<p>Please log in to transfer funds.</p>)}
        </Card>
        </div>
    );

  return (
    isShowing ? ReactDOM.createPortal(
      <React.Fragment>
        <AppModal
          isShowing={isShowing}
          hide={hide}
          size="md"
          header="Transfer to savings"
        >
            {renderForm}
            <AppModal isShowing={showConfirm} hide={() => !isTransferring && setShowConfirm(false)} size="md" header="Confirm Savings Transfer">
                <div className="p-3 text-scheme">
                    <p className="text-muted">You are about to move funds to Savings. Please review the details:</p>
                    <div className="mb-4 p-3 border rounded bg-speem-confirm">
                        <div className="mb-2">
                           <i className="fas fa-university mr-2 text-speem" /> <strong>Destination:</strong> <span className="ml-2">Savings balance</span>
                        </div>
                        <div className="mb-2">
                           <i className="fas fa-user mr-2 text-speem" /> <strong>Recipient:</strong> <span className="ml-2">@{transferReceiver}</span>
                        </div>
                        <div className="mb-0">
                           <i className="fas fa-coins mr-2 text-speem" /> <strong>Amount:</strong> <span className="ml-2">{parseFloat(transferAmount).toFixed(3)} {transferSymbol}</span>
                        </div>
                    </div>
                    <div className="d-flex gap-3 mt-4">
                        <Button color="secondary" onClick={() => setShowConfirm(false)} disabled={isTransferring} className="w-100 mr-2 btn-fancy">
                            Cancel
                        </Button>
                        <Button color="default" onClick={() => handleTransfer()} disabled={isTransferring} className="w-100 btn-fancy position-relative">
                            {isTransferring ? (
                                <span className="spinner dark m-0" />
                            ) : keychainLogin ? (
                                <>
                                Confirm with
                                <img className="icon icon-sm ml-1" src="/assets/img/keychain.svg" />
                                </>
                            ) : (
                                "Confirm"
                            )}
                        </Button>
                    </div>
                </div>
            </AppModal>
        </AppModal>
        <LoginModal
            isShowing={isOpenLoginModal}
            hide={toggleLoginModal}
            requiredActive={requiredActive}
            onSuccess={({ wif }) => { 
                if (wif) {
                handleTransfer(wif);
                } 
            }}
            />
      </React.Fragment>, document.body
    ) : null)
};

export default TransferToSavingsModal;